<template>
  <el-dialog :visible.sync="priceProductDialog" width="40%" :title="titleDialog" class="addBrand">
    <el-form :model="queryParams" label-width="90px">
        <el-row>
            <el-col :span="12">
                <el-form-item label="品牌名称：">
                  {{queryParams.brandName}}
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="系列：">
                  {{queryParams.seriesName}}
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="型号：">
              {{queryParams.proModel}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订货号：">
              {{queryParams.proOrdernum}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
              <el-form-item label="协议设置：">
                <el-select v-model="queryParams.templateType" @change="onChange(queryParams.templateType)">
                  <el-option label="折扣价" :value="1"></el-option>
                  <el-option label="加价率：" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="title">
                <el-col :span="20">
                  <el-input v-model="queryParams.templateRate"></el-input>
                </el-col>
                <el-col :span="4" class="add-right">
                  <span>%</span>
                </el-col>
              </el-form-item>
            </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onConfirm">确 定</el-button>
      <el-button @click="onCancel">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  customerPriceBraSerProUpdate,
  customerPriceTemplateCustomerUpdate
} from '@/api/customer/customerManage'
import { parameterList } from '../../../system/utils/data'
export default {
  data () {
    return {
      priceProductDialog: false,
      queryParams: {
        brandId: '',
        brandName: '',
        templateRate: '',
        templateType: 1,
        bgName: '',
        seriesName: '',
        priceType: '3'
      },
      title: '百分比：',
      titleDialog: '',
      type: 1,
      isClick: 0// 同步至模板状态,0默认不可同步,1数据发生改变可以同步至模板
    }
  },
  methods: {
    // 协议价初始方法
    priceProductEditInitial (type, val) { // type=1协议价模板编辑,2客户协议价编辑
      this.type = type
      this.queryParams = JSON.parse(JSON.stringify(val))
      this.queryParams.templateRate = this.queryParams.templateRate * 100
      this.priceProductDialog = true
      this.titleDialog = '编辑'
    },
    // 协议设置
    onChange (val) {
      if (val === 1) {
        this.title = '折扣额度：'
        this.queryParams.templateRate = '30'
      } else {
        this.title = '加价率:'
        this.queryParams.templateRate = ''
      }
    },
    // 确定
    onConfirm () {
      if (this.type === 1) { // 协议价模板编辑
        customerPriceBraSerProUpdate(this.queryParams).then(res => {
          if (res.data.code === 200) {
            this.$message.success('操作成功!')
            this.$router.push({ query: { id: res.data.obj.cptId } })
            this.$emit('getListProduct')
            this.priceProductDialog = false
          }
        }).catch(err => {
          console.log(err)
        })
      } else if (this.type === 2) { // 客户详情协议价编辑
        const params = JSON.parse(JSON.stringify(this.queryParams))
        params.templateRate = params.templateRate * 0.01
        customerPriceTemplateCustomerUpdate(params).then(res => {
          if (res.data.code === 200) {
            this.$message.success('操作成功!')
            this.isClick = 1
            this.$emit('getListProduct', this.isClick)
            this.priceProductDialog = false
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    // 取消
    onCancel () {
      this.priceProductDialog = false
    }
  }
}
</script>

<style>

</style>
